import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountLeadEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLeadEditContainer";
    }
    render(){
        // console.log("lead edit");
        let self=this;
        $(".zidxAccountLeadEditContainer #lead_assigned_user_id", this.zidx.peakidxShadowRoot).on("change", function(this:HTMLInputElement) {
            ($(".zidxAccountLeadEditContainer #notify1", self.zidx.peakidxShadowRoot)[0] as HTMLInputElement).checked=true;
        });
    }
}